export const SET_GUESTS = 'SET_GUESTS';
export const SET_GUEST = 'SET_GUEST';
export const ADD_GUEST = 'ADD_GUEST';
export const UPDATE_GUEST = 'UPDATE_GUEST';
export const REMOVE_GUEST = 'REMOVE_GUEST';
export const CLEAR_GUEST = 'CLEAR_GUEST';
export const CLEAR_GUESTS = 'CLEAR_GUESTS';
